<div class="json-container bg-gray-900 rounded-lg" [style.maxHeight]="maxHeight">
  <textarea 
    fakturnia-highlight
    [code]="formattedJson"
    [lang]="'json'"
    readonly>
  </textarea>
</div>

